let initUser = {
	member_no: 0,
	iat: 0,
	exp: 0,
	full_name: "Not logged in",
	access_level: 0,
	inactive_timeout: 0
};

const user = (state = initUser, action) => {
	switch (action.type) {
		case 'USER_SUCCESS':
			return action.response;
		case 'LOGIN_SUCCESS':
			return action.response;
		case 'USER_FAILURE':
		case 'LOGOUT_SUCCESS':
			return initUser;
		default:
			return state;
	}
}

export default user